<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h2>№ {{ props.order?.name || "-" }}</h2>
        <div @click="close" class="close-btn">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L11 11M21 21L11 11M11 11L21 1M11 11L1 21"
              stroke="#4D5460"
              stroke-width="2"
            />
          </svg>
        </div>
      </div>
      <div class="modal-body">
        <h3 class="modal-title first">Заказ</h3>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">Завод</span>
            <span class="value">{{ props.order?.warehouse || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Номер заказа</span>
            <span class="value">{{ props.order?.name || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Приоретет</span>
            <span class="value">{{ props.order?.priority || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Длительность операции</span>
            <span class="value">{{ props.order?.duration || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Вес</span>
            <span class="value">{{ props.order?.weight || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Требования к ТС</span>
            <span class="value">{{
              props.order?.driver_loaded_at || "-"
            }}</span>
          </div>
          <div class="info-item">
            <span class="label">Доп указания</span>
            <span class="value">{{
              props.order?.driver_delivered_at || "-"
            }}</span>
          </div>
        </div>
        <h3 class="modal-title">Рейс</h3>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">Статус</span>
            <span class="value">{{
              getStatusText(props.order.status) || "-"
            }}</span>
          </div>
          <div class="info-item">
            <span class="label">Адрес погрузки</span>
            <span class="value">{{ props.order?.loadingAddress || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Время погрузки</span>
            <span class="value">{{ props.order?.loadingTime || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Время доставки</span>
            <span class="value">{{ props.order?.deliveryTime || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">Адрес доставки</span>
            <span class="value">{{ props.order?.deliveryAddress || "-" }}</span>
          </div>
        </div>

        <div class="carrier-customer-container">
          <div class="carrier-section">
            <h3 class="modal-title">Данные перевозчика</h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Перевозчик</span>
                <span class="value">{{ props.order?.carrier || "-" }}</span>
              </div>
              <div class="info-item">
                <span class="label">Рег. номер тягача</span>
                <span class="value">{{ props.order?.truck.number || "-" }}</span>
              </div>
              <div class="info-item">
                <span class="label">Водитель</span>
                <div class="info-item__copy">
                  <span class="value">{{ props.order?.driver || "-" }} </span>
                  <span @click="copy(props?.order?.driver || '-')"
                    ><svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 3.42857C0 1.53502 1.53502 0 3.42857 0H5.95479C6.95568 0 7.90659 0.437358 8.55796 1.19729L9.68681 2.51429H7.88054L7.51669 2.0898C7.12587 1.63384 6.55532 1.37143 5.95479 1.37143H3.42857C2.29244 1.37143 1.37143 2.29244 1.37143 3.42857V8.91429C1.37143 10.0504 2.29244 10.9714 3.42857 10.9714H4.34286V12.3429H3.42857C1.53502 12.3429 0 10.8078 0 8.91429V3.42857Z"
                        fill="#CACCCF"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.91429 3.65714C7.02074 3.65714 5.48571 5.19217 5.48571 7.08571V12.5714C5.48571 14.465 7.02074 16 8.91429 16H12.5714C14.465 16 16 14.465 16 12.5714V8.40513C16 7.58669 15.7072 6.79525 15.1746 6.17384L14.0437 4.85443C13.3923 4.0945 12.4414 3.65714 11.4405 3.65714H8.91429ZM6.85714 7.08571C6.85714 5.94959 7.77816 5.02857 8.91429 5.02857H11.4405C12.041 5.02857 12.6116 5.29099 13.0024 5.74694L14.1333 7.06635C14.4529 7.4392 14.6286 7.91406 14.6286 8.40513V12.5714C14.6286 13.7076 13.7076 14.6286 12.5714 14.6286H8.91429C7.77816 14.6286 6.85714 13.7076 6.85714 12.5714V7.08571Z"
                        fill="#CACCCF"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="customer-section">
            <h3 class="modal-title">Заказчик</h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Клиент</span>
                <span class="value">{{ props.order?.client || "-" }}</span>
              </div>
              <div class="info-item">
                <span class="label">Контактное лицо</span>
                <span class="value">{{
                  props.order?.clientContact || "-"
                }}</span>
              </div>
              <div class="info-item">
                <span class="label">Грузополучатель</span>
                <span class="value">{{ props.order?.consignee || "-" }}</span>
              </div>
              <div class="info-item">
                <span class="label">Примечание</span>
                <span class="value">{{ props.order?.notes || "-" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { useOrderStatus } from "@/composables/useOrderStatus";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  order: {
    type: Object,
    default: null,
  },
});
const emit = defineEmits(["close"]);

const { getStatusText } = useOrderStatus();

const copy = async (item) => {
  try {
    await navigator.clipboard.writeText(item);
  } catch (err) {
    console.error("Failed to copy text: ", err);
  }
};

const close = () => {
  emit("close");
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  cursor: pointer;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  // background-color: var(--body-color);
  background-color: #fff;
  padding: 24px;
  border-radius: 16px;
  width: 100%;
  max-width: 1050px;
  max-height: 100vh;
  overflow-y: auto;

  @media (max-width: 1200px) {
    max-width: 65%;
  }
  @media (max-width: 1024px) {
    padding: 14px;
    max-height: 90vh;
    overflow-y: hidden;
  }

  @media (max-width: 768px) {
    padding: 16px;
    max-width: 95%;
    overflow-y: auto;
  }

  @media (max-height: 800px) {
    padding: 14px;
    max-height: 90vh;
    overflow-y: auto;
  }
}
.modal-body {
  overflow-y: auto;
}
.carrier-customer-container {
  display: flex;
  gap: 20px;

  .carrier-section,
  .customer-section {
    flex: 1;
  }

  .carrier-section {
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-bottom: 14px;
  }

  @media (max-height: 800px) {
    margin-bottom: 14px;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    font-family: Open Sans, sans-serif;
    // color: var(--text-color);
    color: #4d5460;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
}

.close-btn {
  cursor: pointer;
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  font-family: Open Sans, sans-serif;
  // color: var(--text-color);
  color: #4d5460;
  margin-top: 24px;
  margin-bottom: 16px;
  @media (max-height: 800px) {
    font-size: 14px;
    margin-top: 14px;
    margin-bottom: 10px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
    margin-top: 14px;
    margin-bottom: 10px;
  }

  &.first {
    margin-top: 0;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;

  .info-item:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
}

.info-item {
  display: flex;
  column-gap: 8px;
  align-items: center;
  padding-bottom: 4px;
  line-height: 1;
  // border-bottom: 1px solid var(--border-color);
  border-bottom: 1px solid #dde5ed;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }

  &__copy {
    display: flex;
    column-gap: 8px;
    cursor: pointer;
  }
}

.label {
  font-size: 14px;
  width: 200px;
  // color: var(--text-color);
  color: #4d5460;
  font-family: Open Sans, sans-serif;
  margin-bottom: 4px;
  @media (max-width: 1024px) {
    width: 100%;
    max-width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
  @media (max-width: 768px) {
    font-size: 12px;
    width: 100%;
  }
}

.value {
  font-size: 14px;
  font-weight: 600;
  // color: var(--text-color);
  color: #4d5460;
  font-family: Open Sans, sans-serif;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}
</style>
